define('views/filter/index',['require','underscore','views/base/view','text!templates/filter/index.ejs','models/modals/filter/index','views/modals/filter/index'],function(require) {
    'use strict';

    var _ = require('underscore'),
        View = require('views/base/view'),
        template = require('text!templates/filter/index.ejs'),
        FilterModalModel = require('models/modals/filter/index'),
        FilterModalView = require('views/modals/filter/index');

    var FilterView = View.extend({
        autoRender: false,
        template: template,
        listen: {
            'openFilter model': 'onOpenFilter',
            'filterChanged model': 'render',
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            this.$el.off('click', '.close');
            this.delegate('click', '.close', this.resetFilter);
        },
        resetFilter: function() {
            console.log('Reset filter');
            var model = this.model;
            model.reset();
            model.set('visible', false);
            model.trigger('filterChanged');
        },
        saveFilter: function(name, attrs) {
            this.model.trigger('saveFilter', name, this.model.getFilter(attrs.schema));
        },
        onOpenFilter: function() {
            var _this = this;

            var model = this.model;
            var modalModel = new FilterModalModel();

            modalModel.content.set(_.clone(model.attributes, true));

            this.subview('modal', new FilterModalView({ model: modalModel }));

            modalModel.on('saveFilter', function(name) {
                _this.saveFilter(name, _.clone(modalModel.content.attributes, true));
            });

            modalModel.on('action', function(action) {
                if (action==='reset') {
                    _this.resetFilter();
                }
                if (action==='apply') {
                    model.set(_.clone(modalModel.content.attributes, true));

                    model.set('visible', model.hasSelection());
                    model.trigger('filterChanged');
                }
            });
        }
    });

    return FilterView;
});

